import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, Row } from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';


const AlarmCategoryAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [alarmCategoryAttrs, setAlarmCategoryAttrs] = useState({
    code: '',
    description: '',
    notifTypeId: ''
  });

  const [errMsg, setErrMsg] = useState('');
  const [notifTypeList, setNotifTypeList] = useState([]);

  // UI Functions

  // Initialize state
  useEffect(() => {

    fetchNotifTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types?searchTerms=");

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data.data && res.data.data.length > 0)) {
          setNotifTypeList(res.data.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const onAttrsInputChange = (e) => {
    setAlarmCategoryAttrs({ ...alarmCategoryAttrs, [e.target.name]: e.target.value })
  }

/*
  const onNotifTypeSelect = (key, event) => {

    // Deep copy, Make a deep copy
    let newAttr = JSON.parse (JSON.stringify(alarmCategoryAttrs));
    newAttr.notifTypeId = key;
    newAttr.notifType   = notifTypeList.find( item => item.id.toString() === key.toString()).name;

    setAlarmCategoryAttrs(newAttr);
  };
*/

  const onNotifTypeClick = (key, event) => {

    // Deep copy, Make a deep copy
    let newAttr = JSON.parse (JSON.stringify(alarmCategoryAttrs));
    newAttr.notifTypeId = key;
    newAttr.notifType   = notifTypeList.find( item => item.id.toString() === key.toString()).name;

    setAlarmCategoryAttrs(newAttr);
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!alarmCategoryAttrs.code || alarmCategoryAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_alarm_rule_code"));
    } else if (alarmCategoryAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
    } else {
      validateCode();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateCode() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("alarm-categories?code=" + alarmCategoryAttrs.code);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_Dup_alarm_cat_code"));
        } else {
          validateOtherFields();
        }

        return;
      } catch (error) {

        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }

        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (!alarmCategoryAttrs.description || alarmCategoryAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (alarmCategoryAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (!alarmCategoryAttrs.notifTypeId || alarmCategoryAttrs.notifTypeId.length === 0) {
      if (configInfo.uiConfig.visibleFields.ALARMCAT_NotifType) {
        setErrMsg(t("I18N_ERR_Need_notif_type"));
      } else {
        // If Notif Type not needed, fill in a dummy value
        setAlarmCategoryAttrs({ ...alarmCategoryAttrs, notifTypeId: 10000011 })
      }
    } else {
      setErrMsg('');
      createNewAlarmCategory();
    }
  }

  const createNewAlarmCategory = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(alarmCategoryAttrs));

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("alarm-categories", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', height: '800px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Alarm_Category")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_AlarmCategory_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_AlarmCategory_code")}: *</Col>
              <Col>{t("I18N_Description")}: *</Col>
              { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
                <Col>{t("I18N_Notif_type")}: *</Col>
              :
                <Col></Col>
              }
              <Col></Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code" value={alarmCategoryAttrs.code}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={alarmCategoryAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              { configInfo.uiConfig.visibleFields.ALARMCAT_NotifType ?
              <Col>
                <Dropdown>
                  <Dropdown.Toggle size="tiny_dropdown" variant="outline-secondary" className={classes.dropdown_item_wrap} id="dropdown-basic-button">
                    {!alarmCategoryAttrs.notifTypeId ? t("common:I18N_DROPDOWN_PROMPT") :
                       notifTypeList.find( item => item.id.toString() === alarmCategoryAttrs.notifTypeId.toString()).name}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: "600px", overflowY: "auto"}} id="dropdown-basic-button" >
                    {notifTypeList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap} onClick={() => onNotifTypeClick(item.id)}>
                          {item.id ? item.name : t("common:I18N_No_parent_menu")}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              :
                <Col></Col>
              }
              <Col></Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default AlarmCategoryAdminNewView;
